module.exports = __webpack_public_path__ + "media/images/icons/new-used-car-a17ccc8e721c288c637b04b6f882169c.svg";